import { Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

export class VentanaFlotante<T = any> {
  private subscriptions: Subscription[] = [];

  constructor(
    public dialogRef: MatDialogRef<T>,
    @Inject(MAT_DIALOG_DATA) public data: any|null,
  ) {}

  onClose(): void {
    this.unsubscribeAll();
    this.dialogRef.close();
  }

  unsubscribeAll(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions = [];
  }
}